import { Box } from '@zillow/constellation-10';
import { forwardRef } from 'react';

type SkeletonContainerProps = {
  children: React.ReactNode;
};

const SkeletonContainer = forwardRef<HTMLDivElement, SkeletonContainerProps>(({ children }, ref) => (
  <Box ref={ref} aria-label="loading" role="status" css={{ pointerEvents: 'none' }}>
    {children}
  </Box>
));

SkeletonContainer.displayName = 'SkeletonContainer';

export default SkeletonContainer;
